import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContractObservationsService {

  constructor(
    private http: HttpClient,
  ) { }

  async getObservationsByContract(contractId: number) {
    return await lastValueFrom<any>(this.http.get(`${environment.apiUrl}/contract-observations/contract/${contractId}`));
  }

  async getContractAvisosForDeclaration(contractId: number, declarationId: number) {
    return await lastValueFrom<any>(this.http.get(`${environment.apiUrl}/contract-observations/contract/${contractId}/for-declaration/${declarationId}`));
  }

  async getObservationsByContractLog(contractId: number) {
    return await lastValueFrom<any>(this.http.get(`${environment.apiUrl}/contract-observations/contract/${contractId}/log`));
  }

  async getObservationsByDeclaration(declarationId: number) {
    return await lastValueFrom<any>(this.http.get(`${environment.apiUrl}/contract-observations/declaration/${declarationId}`));
  }

  async getVisibleAvisosForDeclaration(declarationId: number) {
    return await lastValueFrom<any>(this.http.get(`${environment.apiUrl}/contract-observations/declaration/${declarationId}/visible-avisos`));
  }

  async createObservation(observation: any) {
    return await lastValueFrom<any>(this.http.post(`${environment.apiUrl}/contract-observations`, observation));
  }

  async updateObservation(id: number, observation: any) {
    return await lastValueFrom<any>(this.http.put(`${environment.apiUrl}/contract-observations/${id}`, observation));
  }

  async deleteObservation(id: number) {
    return await lastValueFrom<any>(this.http.delete(`${environment.apiUrl}/contract-observations/${id}`));
  }
}

